import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { AuthServiceService } from '@services/auth-service.service';
import { Globals } from 'src/app/globals';
import { RegUser } from '../basic-reg/RegUser';

@Component({
  selector: 'app-private-schools',
  templateUrl: './private-schools.component.html',
  styleUrl: './private-schools.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ]
})
export class PrivateSchoolsComponent implements OnInit {

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  constructor(private authService: AuthServiceService, public global: Globals) { }

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser();
  }

  ionViewWillEnter() {
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

  levels = [
    {
      title: "Level 0 – Student Sign Up",
      data: [
        { name: "HIDDIN", percent: 30, color: "bg-blue-500" },
        { name: "HIDDIN Sales", percent: 10, color: "bg-purple-500" },
        { name: "School’s General Fund", percent: 60, color: "bg-green-500" },
      ],
    },
    {
      title: "Level 1 – Student’s Sign Ups (12)",
      data: [
        { name: "HIDDIN", percent: 30, color: "bg-blue-500" },
        { name: "HIDDIN Sales", percent: 10, color: "bg-purple-500" },
        { name: "School’s General Fund", percent: 50, color: "bg-green-500" },
        { name: "Participants’ Commission", percent: 10, color: "bg-yellow-500" },
      ],
    },
    {
      title: "Level 2 – 144+ Sign Ups",
      data: [
        { name: "HIDDIN", percent: 30, color: "bg-blue-500" },
        { name: "Participants’ Commission", percent: 10, color: "bg-yellow-500" },
        { name: "Tuition Reimbursement Endowment", percent: 5, color: "bg-red-500" },
        { name: "Health & Education Credits", percent: 25, color: "bg-teal-500" },
        { name: "Fee Endowment", percent: 30, color: "bg-indigo-500" },
      ],
    },
  ];

}

